import React,{useRef,useState} from 'react';
export default function SmartBookingManage({token,appointment,request,format,onDone}) {
 const [action,setAction]=useState(''),[slots,setSlots]=useState([]),[selected,setSelected]=useState(''),
  [due,setDue]=useState(''),[busy,setBusy]=useState(false),[error,setError]=useState('');
 const receipt=useRef(null);
 async function choose(next) {
  setAction(next);setError('');setSelected('');setDue('');setSlots([]);
  if(next==='reschedule') {
   setBusy(true);
   try {setSlots((await request('change-options',{token})).slots);}
   catch(e){setError(e.message);}
   finally {setBusy(false);}
  }
 }
 async function submit() {
  const body={token,action,expected_start:appointment.start_at,replacement:action==='reschedule'?selected:null,document_due:due||null};
  const digest=JSON.stringify(body);
  if(receipt.current?.digest!==digest) receipt.current={digest,key:Array.from(crypto.getRandomValues(new Uint8Array(16)),v=>v.toString(16).padStart(2,'0')).join('')};
  setBusy(true);setError('');
  try {onDone(await request('manage',{...body,operation_id:receipt.current.key}));setAction('');receipt.current=null;}
  catch(e){setError(e.message);}
  finally{setBusy(false);}
 }
 return <section><fieldset disabled={busy}><button type="button" onClick={()=>choose('reschedule')}>Termin umbuchen</button>{' '}
  <button type="button" onClick={()=>choose('cancel')}>Termin absagen</button>
  {action==='reschedule'&&<><label className="block">Ersatztermin<select value={selected} onChange={e=>setSelected(e.target.value)}>
   <option value="">Zeit auswählen</option>{slots.map(v=><option key={v} value={v}>{format(v)}</option>)}</select></label>
   {appointment.document_due&&<label className="block">Unterlagenfrist ändern (bisher {appointment.document_due.split('-').reverse().join('.')})
     <input type="date" value={due} onChange={e=>setDue(e.target.value)}/></label>}
   <button type="button" disabled={!selected} onClick={submit}>Ersatztermin verbindlich vereinbaren</button></>}
  {action==='cancel'&&<><p>Möchten Sie den Termin am {format(appointment.start_at)} absagen?</p>
   <button type="button" onClick={submit}>Absage bestätigen</button></>}
  {action&&<button type="button" onClick={()=>choose('')}>Zurück</button>}</fieldset>{error&&<p role="alert">{error}</p>}</section>;
}
